import createDataHook from "..";
import { clearCachedUser, fetchCurrentUser } from "./data-fetcher";
import type { IUser } from "../../interfaces";

export { clearCachedUser as clearCachedUser };
export default createDataHook<IUser | null>(null, fetchCurrentUser);
